var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1757655080665,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 19914,
    width: 24,
    height: 24,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M341.333333 648.533333c0-157.013333 157.013333-286.72 351.573334-290.133333 6.826667 0 10.24-3.413333 13.653333-6.826667 3.413333-3.413333 3.413333-10.24 3.413333-13.653333-37.546667-150.186667-180.906667-252.586667-348.16-252.586667C160.426667 85.333333 0 232.106667 0 409.6v6.826667c0 71.68 27.306667 139.946667 81.92 194.56l10.24 10.24c10.24 17.066667 23.893333 27.306667 40.96 40.96l-61.44 116.053333c-3.413333 6.826667-3.413333 13.653333 3.413333 20.48 3.413333 3.413333 6.826667 3.413333 10.24 3.413333 3.413333 0 6.826667 0 10.24-3.413333l129.706667-88.746667c34.133333 13.653333 71.68 20.48 109.226667 23.893334 6.826667 0 10.24-3.413333 13.653333-6.826667 3.413333-3.413333 3.413333-10.24 3.413333-13.653333-6.826667-23.893333-10.24-44.373333-10.24-64.853334z m-245.76-40.96z",
    fill: "#07c160",
    "p-id": 19915
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1024 648.533333c0-139.946667-146.773333-256-324.266667-256S375.466667 508.586667 375.466667 648.533333s146.773333 256 324.266666 256c17.066667 0 34.133333 0 54.613334-3.413333 17.066667-3.413333 30.72-3.413333 44.373333-10.24l98.986667 44.373333h6.826666c3.413333 0 6.826667 0 10.24-3.413333 6.826667-3.413333 6.826667-10.24 6.826667-17.066667l-20.48-64.853333c75.093333-47.786667 122.88-122.88 122.88-201.386667z",
    fill: "#07c160",
    "p-id": 19916
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.f9781afa.svg";
export { ForwardRef as ReactComponent };